import React from 'react';
import { Link as CLink, LinkProps as CLinkProps } from '@chakra-ui/react';
import { Link, LinkProps } from 'react-router-dom';

type ChakraLinkProps = LinkProps & CLinkProps;

export const ChakraLink: React.FC<ChakraLinkProps> = ({
  children,
  ...rest
}) => {
  return (
    <CLink as={Link} {...rest}>
      {children}
    </CLink>
  );
};
